<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        <a href="#" @click.prevent="goBack"><i class="fa fa-angle-left"></i></a>
        Trazabilidad: lote (<span v-if="numLote">{{ numLote }})</span>
      </h1>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <b-spinner class="text-center" v-if="!items.length"></b-spinner>

            <div v-if="items.length">
              <b-table striped hover small :items="items" :fields="fields"> </b-table>
              <h5 class="mb-2 font-weight-bold">
                Pallets en lote (<span v-if="numLote">{{ numLote }})</span>
              </h5>
              <b-table striped hover small :items="itemsPallet" :fields="fieldsPallet">
                <template v-slot:cell(Pallet)="data">
                  <a
                    target="_blank"
                    href="#"
                    title="Ver en detalle"
                    @click.prevent="seeDetailContent(data.item.pallet_id, data.item.pallet)"
                    >{{ data.item.pallet }}</a
                  >
                </template>
              </b-table>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import moment from "moment";

Vue.use(ClientTable);

export default {
  name: "detailedLote",
  props: ["waybill_id", "numLote"],
  created() {},
  data() {
    return {
      items: [],
      fields: [
        { key: "product_name", label: "Especie", sorteable: true },
        { key: "product_type_name", label: "Tipo", sorteable: true },
        { key: "variety_name", label: "Variedad", sorteable: true },
        { key: "condition", label: "Condición", sorteable: true },
        { key: "origin_name", label: "Huerto", sorteable: true }
      ],
      itemsPallet: [],
      fieldsPallet: ["Pallet", "Formato", "Cantidad", "Especificaciones", "Kg_Brutos", "Kg_Netos"]
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    }
  },
  computed: {},
  methods: {
    getContents(a) {
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_lot_trazability/")
        .then((res) => {
          const data = res.data;
          const items = [];
          for (let key in data) {
            const item = data[key];
            items.push(item);
          }
          this.items = items;

          this.itemsPallet = [];
          const datos = this.items[0].content_set;
          for (let key in datos) {
            var rowNew = {
              pallet: datos[key].pallet_number,
              pallet_id: datos[key].pallet,
              Formato: datos[key].container_name,
              Cantidad: datos[key].quantity,
              Especificaciones: datos[key].string_specs,
              Kg_Brutos: datos[key].gross_kilograms,
              Kg_Netos: datos[key].net_kilograms
            };
            this.itemsPallet.push(rowNew);
          }
        })
        .catch((error) => console.log(error));
    },
    seeDetailContent(id_pallet, numero_pallet) {
      this.$router.push("/trazabilidad/detailed-pallet-trazability/" + id_pallet + "/" + numero_pallet);
    },
    goBack() {
      this.$router.go(-1);
    },
    moment: function () {
      return moment();
    }
  },
  mounted() {
    this.getContents(this.waybill_id);
  }
};
</script>
